import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Filter } from 'src/app/shared/models/filter';
import { FilterResponse } from 'src/app/shared/models/filter-response';

@Component({
    selector: 'cdp-filter-item',
    templateUrl: './filter-item.component.html',
    styleUrls: ['./filter-item.component.scss'],
    standalone: false
})
export class FilterItemComponent {
    private valueChangesSub: Subscription;
    private _filterItems: Array<Filter>;

    get filterItems(): Array<Filter> {
        return this._filterItems;
    }
    @Input() set filterItems(value: Array<Filter>) {
        if (value !== this._filterItems) {
            this._filterItems = [...value];
        }
    }

    private _form: FormGroup;
    @Input() set form(form: FormGroup) {
        this._form = form;
        this.subscribeToFormChanges();
    }
    get form(): FormGroup {
        return this._form;
    }

    @Output() selectionChange: EventEmitter<FilterResponse<any>> = new EventEmitter<FilterResponse<any>>();

    trackByFn(index: number) {
        return index;
    }

    subscribeToFormChanges() {
        if (this.valueChangesSub) {
            this.valueChangesSub.unsubscribe();
        }
        this.valueChangesSub = this.form.valueChanges.subscribe(() => {
            if (this._filterItems && this._form) {
                const formValues = this._form.value;
                this._filterItems.forEach(item => {
                    const controlName = item.formControlName;
                    switch (item.filterType) {
                        case 'multi-select':
                        case 'single-select':
                        case 'yes-no':
                            item.selections = formValues[controlName];
                            break;
                        case 'min-max':
                            item.selectionMin = formValues[controlName + 'Min'] ?? item.selectionMin;
                            item.selectionMax = formValues[controlName + 'Max'] ?? item.selectionMax;
                            break;
                        case 'date-picker':
                            item.dateMin = formValues[controlName + 'Min'] ?? item.dateMin;
                            item.dateMax = formValues[controlName + 'Max'] ?? item.dateMax;
                            break;
                        default:
                            // For any other types, just assign the value
                            item.selections = formValues[controlName];
                    }
                });
            }
        });
    }
}
